import React from 'react';
import LinkedinShortIcon from './icons/LinkedinShortIcon.jsx';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import LinkedinIcon from './icons/LinkedinIcon.jsx';

export default function LinkedinFeedButton({ disabled, cert, onSendEvent, fullIcon }) {
    const { t } = useTranslation();

    const button = () => (
        <Stack
            direction={'row'}
            sx={{ alignItems: 'center', justifyContent: 'center' }}
            style={{
                width: '92%',
                textDecoration: 'none',
                padding: '12px',
                borderRadius: '8px',
                borderColor: disabled ? '#F6F6F6' : '#2867B2',
                background: disabled ? 'rgb(246, 246, 246)' : '#2867B2',
                cursor: disabled ? 'default' : 'pointer',
            }}
        >
            <LinkedinShortIcon fill={disabled ? '#CCC9D1' : '#FFF'} />
            <Typography
                variant={'bodyMenu'}
                sx={{ color: disabled ? 'rgba(0, 0, 0, 0.26)' : 'rgb(255, 255, 255)', ml: 1 }}
            >
                {t('certificate.share.linkedin-post')}
            </Typography>
        </Stack>
    );

    const a = (disabled, fullIcon) => {
        const element = fullIcon ? (
            button()
        ) : (
            <LinkedinIcon fill={!disabled ? '#2867B2' : '#F6F6F6'} icon={!disabled ? '#FFF' : '#CCC9D1'} />
        );
        return disabled ? (
            element
        ) : (
            <a
                href={'https://www.linkedin.com/oauth/v2/authorization?'
                    .concat('&response_type=code')
                    .concat('&client_id=')
                    .concat(import.meta.env.VITE_LINKEDIN_CLIENT_ID)
                    .concat('&redirect_uri=')
                    .concat(encodeURIComponent(new URL(import.meta.env.VITE_VIEWER_API_ROOT).origin.concat('/li')))
                    .concat('&state='.concat(cert.id))
                    .concat('&scope=w_member_social openid profile')}
                target={'_self'}
                onClick={() => onSendEvent('linkedin-flow')}
                style={{
                    textDecoration: 'none',
                }}
            >
                {element}
            </a>
        );
    };

    return <>{a(disabled, fullIcon)}</>;
}
